/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createInstrumentSyncEntity} from '../api'

export const useMutationCreateInstrumentSyncEntity = createReactQueryMutationHook('createInstrumentSyncEntity', createInstrumentSyncEntity)
